export default "__VITE_ASSET__bbc34356__"